<template>
  <!-- 理赔查询 -->
  <div id="claimWorkOrder">
    <div class="yto-box y-pd-0 nCustomPrint">
      <!-- <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
        <el-tab-pane label="快速理赔" name="quickIndemnity"></el-tab-pane>
        <el-tab-pane label="理赔工单" name="claim"></el-tab-pane>
      </el-tabs> -->
      <!-- <claim v-if="activeName=='claim'"></claim> -->
      <quick-indemnity ref="quickIndemnity" :realNameInfo='realNameInfo'></quick-indemnity>
    </div>
  </div>
</template>

<script>
import claim from './claim'; // 理赔工单
import QuickIndemnity from './quickIndemnity.vue';
export default {
  components: {
    claim,
    QuickIndemnity,
  },
  name: 'claimWorkOrder',
  mixins: [],
  data() {
    return {
      activeName: 'quickIndemnity',
      realNameInfo:{}
    };
  },
  computed: {
    userMess() {
      return this.$store.state.user;
    }
  },
  beforeCreate() {},
  created() {
    console.log(111,this.$route.query)
    if(this.$route.query && this.$route.query.auth_code){
      this.activeName = 'quickIndemnity';
      this.realNameInfo = JSON.parse(JSON.stringify(this.$route.query));
      this.$nextTick(() => {
        this.$refs.quickIndemnity.openRealName()
      })
    }else if(this.$route.query && this.$route.query.activeName && this.$route.query.activeName == 'quickIndemnity'){
      this.activeName = 'quickIndemnity';
    }else{
      this.activeName = 'quickIndemnity';
    }
  },
  mounted() {
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" rel="stylesheet/scss" scoped>
@import '../../styles/variables';
.hilightColor {
  color: $blue-style;
  cursor: pointer;
}
#claimWorkOrder{
  .el-tabs{
    // background-color: #fff;
  }
}
.mr5 {
    margin-right: 5px;
}
.mr20 {
    margin-right: 20px;
}
.mb20 {
    margin-bottom: 20px;
}
.mt20 {
    margin-top: 20px;
}
// .tooltip-style{
//     width: 1000px;
// }

</style>
